require('initializers/gettext').default(__TRANSLATIONS__.gettext.pl); // eslint-disable-line no-undef
require('initializers/i18n').default('pl', __TRANSLATIONS__.i18n.pl); // eslint-disable-line no-undef

require('locales/dependencies');

require('select2/dist/js/i18n/pl');
require('jquery-ui/ui/i18n/datepicker-pl');
require('dayjs/locale/pl');
